import './designYourDeposit.scss';

import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FullForm from '../../ares/Layouts/FullForm';
import { formatText } from 'core/i18n';
import { JoinHolderTable } from './components/joinHolderTable';
import { InformationMessage } from '../informationMessage/informationMessage';
import { DepositAmountInput } from './components/depositAmountInput';
import { getAllJointHolders } from 'utilities/jointHolders/jointHoldersHelper';
import { recordEventCustomOnly } from 'utilities/uTagging';
import UtagHelper from 'utilities/utagHelper';
import cryptoJS from 'crypto-js';
import { recordAndSavePage } from 'actions/errorViewNavigation';
import { getGA4EventKeys } from 'utilities/ga4';

export const DesignYourDepositComponent = ({
    userProfile,
    formActions,
    depositActions,
    products,
    modalCancelActions,
    recordAndSavePage,
}) => {
    useEffect(() => {
        const JointHolderInfo = UtagHelper.getJointHolderInfoFromUserProfile(userProfile);
        const docNumberEncrypted = userProfile.docNumber ? cryptoJS.SHA256(userProfile.docNumber).toString() : '';
        recordAndSavePage(
            '/onboarding/deposito-configuracion',
            userProfile.recordId,
            userProfile.userId,
            userProfile.product,
            products.get('productsDescription'),
            userProfile.promoCode ? userProfile.promoCode : '',
            JointHolderInfo,
            '',
            '',
            userProfile.investmentType,
            {
                ...getGA4EventKeys({
                    eventName: 'step_deposit_configuration',
                    pageName: '/onboarding/step3/depositConfiguration',
                    processDetail: 'depositConfiguration',
                    onboardingType: userProfile.investmentType,
                }),
                identificadorOnboarding: docNumberEncrypted,
                tipoProceso: 'onboarding',
                pasoProceso: 'deposito-configuracion',
                processStep: 'step3',
            }
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const cancelOnboarding = () => {
        modalCancelActions.showModalCancel();
        recordEventCustomOnly({
            accionEvento: 'salir',
            categoriaEvento: '/onboarding/deposito-configuracion',
        });
    };

    const tagTooltipEvent = () => {
        recordEventCustomOnly({
            accionEvento: 'tooltip tipo intervencion',
            categoriaEvento: '/onboarding/deposito-configuracion',
        });
    };

    const tagInputFocus = () => {
        recordEventCustomOnly({
            accionEvento: 'input importe',
            categoriaEvento: '/onboarding/deposito-configuracion',
            event_name: 'field_fullfilled',
            action: 'type',
            format: 'textField',
            component: 'form',
            element: 'deposit_amount',
        });
    };

    const sendDeposit = () => {
        recordEventCustomOnly({
            accionEvento: 'continuar',
            categoriaEvento: '/onboarding/deposito-configuracion',
            event_name: 'button_click',
            action: 'click',
            format: 'button',
            component: 'form',
            element: 'continue',
        });
        userProfile.depositValue && depositActions.sendDeposit();
    };

    const changeDepositValue = value => {
        formActions.change('userProfile.depositValue', value);
    };

    const userInfo = {
        formattedAccountType: formatText('jointHolderAccountType-titular'),
        fullName: `${userProfile.name} ${userProfile.lastName} ${userProfile.secondLastName || ''}`,
    };

    const depositUsersInfo = [userInfo, ...getAllJointHolders(userProfile)];

    return (
        <FullForm
            title={formatText('stepsTitles-deposit')}
            continueAction={sendDeposit}
            formModel="userProfile"
            icon="deposits"
            continueButtonEnabled={userProfile.depositValue}
            hideRoadMapNavigation={false}
            cancelAction={cancelOnboarding}
        >
            <div className="design-your-deposit">
                <DepositAmountInput changeDepositValue={changeDepositValue} handleOnFocus={tagInputFocus} />
                <div className="design-your-deposit-content">
                    <JoinHolderTable onClickTooltip={tagTooltipEvent} joinHolders={depositUsersInfo} />
                    <InformationMessage text={formatText('deposit-conditions')} />
                </div>
            </div>
        </FullForm>
    );
};

const mapDispatchToProps = dispatch => ({
    recordAndSavePage: bindActionCreators(recordAndSavePage, dispatch),
});

export const DesignYourDeposit = connect(null, mapDispatchToProps)(DesignYourDepositComponent);
